import { Button, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect } from "react";

const TableSearchButton = ({ setEnableSearch, EnableSearch, id = "", onClick = () => { } }) => {

  useEffect(() => {
    if (EnableSearch === true) {
      const focusItem = document.getElementById(id);
      if (focusItem) {
        focusItem.focus()
        focusItem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [EnableSearch, id]);

  return (
    <Tooltip title="Search" placement="top">
      <Button
        sx={{
          whiteSpace: "nowrap",
          border: EnableSearch ? "2px solid white" : "1px solid white",
          boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
          m: { sm: "0 6px", md: "0 10px" },
          fontWeight: "bold",
          backgroundColor: EnableSearch ? "#f3724a" : "white",
          "&:hover": {
            backgroundColor: EnableSearch ? "#f3724a" : "white",
            border: EnableSearch ? "2px solid white" : "1px solid white",
          },
          "&:active": {
            transform: "scale(0.92)",
            boxShadow: "inset 0px 0px 5px rgba(0, 0, 0, 0.4)",
          },
          height: "30px",
          minWidth: "10px",
          width: "30px",
        }}
        variant="outlined"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setEnableSearch((prev) => !prev);
          onClick(!EnableSearch)
        }}
      >
        <SearchIcon sx={{ fontSize: 20 }} />
      </Button>
    </Tooltip>
  );
};

export default TableSearchButton;
